module.exports = __webpack_public_path__ + "static/media/34518736-38bd-4857-9712-cf284fa9ba14.b9d6c95e.png";